export default {
      id: "oc-menu-dashboard-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-menu-dashboard",
      toString: function () {
        return this.url;
      }
    }